<template>
  <v-app id="onHefcTmp">

    <defNavBar title="Ares - Host proforma invoice" :actions="hefc.action_items" :home="true" @actionClick="actionClick"/>
    
    <v-main>       
      <v-container fluid>
        <v-row cols="12">  
          
          <v-col cols="6" class="px-1"> <!-- Links -->
            <v-container>
              <v-row>
                <v-col cols="12" class="px-1">
                  <v-card>
                  <v-form ref="hefcCard1">
                  <v-card-title>
                    Proforma Invoice {{ hefc.hefc_nr }} 
                  </v-card-title>

                  <v-row no-gutters>
                    <v-col cols="4" class="px-1">
                      <v-text-field v-model="hefc.hefc_dt" readonly label="Invoice date"></v-text-field>
                    </v-col>
                    <v-col cols="8" class="px-1">
                      <v-text-field v-model="hefc.hefc_oms" readonly label="Description"></v-text-field>
                    </v-col>
                  </v-row>
                  
                  <v-row no-gutters>
                    <v-col cols="4" class="px-1">
                      <v-text-field v-model="hefc.eign_naam" readonly label="Host"></v-text-field>
                    </v-col>
                    <v-col cols="2" class="px-1">
                      <v-text-field v-model="hefc.land_code" readonly label="Country"></v-text-field>
                    </v-col>
                    <v-col cols="2" class="px-1">
                      <v-text-field v-model="hefc.eign_btw" readonly label="VAT"></v-text-field>
                    </v-col>
                    <v-col cols="2" class="px-1">
                      <v-text-field v-model="hefc.land_code_btw" readonly label="Country VAT"></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row no-gutters>   
                      <v-spacer></v-spacer><v-btn class="primary ma-2" x-small @click="addHefr(hefc_encrid)">Add Line</v-btn>
                  </v-row> 
                  
                  <v-row no-gutters>
                    <v-col cols="12" class="px-1">
                  <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <td>Item</td>
                            <td>Description</td>
                            <td align="right">Excl VAT</td>
                            <td>VAT id</td>
                            <td align="right">VAT</td>
                            <td align="right">Total</td>
                          </tr>  
                        </thead>  
                        <tbody v-for="(hefrRecord,i) in hefc.hefr" :key="i">
                          <tr>
                           <td>{{hefrRecord.hfrttaal_oms}}</td> 
                           <td>{{hefrRecord.hefr_oms}}</td>
                           <td align="right">{{hefrRecord.hefr_bedrag_excl}}</td>
                           <td>{{hefrRecord.hefr_btwcode}}</td>
                           <td align="right">{{hefrRecord.hefr_bedrag_btw}}</td>
                           <td align="right">{{hefrRecord.hefr_bedrag_incl}}</td>
                           <td><v-btn v-if="hefrRecord.rmHefr === 'Yes'" text icon  @click="rmHefr(hefrRecord.hefr_encrid)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn></td>
                          </tr>
                          <tr v-for="(hfrdRecord,j) in hefrRecord.hfrd" :key="j"> 
                              <td></td>
                              <td>{{hfrdRecord.hfrd_oms}}</td> 
                              <td align="right" v-if="hfrdRecord.hfrd_deci_val == 'Yes'">{{hfrdRecord.hfrd_deci}}</td> 
                          </tr>  
                        </tbody>
                      </template>
                    </v-simple-table>
                     <rmHefr ref="rmHefr"></rmHefr>
                     <addHefr ref="addHefr"></addHefr>
                    </v-col>
                  </v-row>                    
                  </v-form>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <rmHefc ref="rmHefc"></rmHefc>
    <sentHefcByEmail ref="sentHefcByEmail"></sentHefcByEmail>
    <tmpHefcToHefc ref="tmpHefcToHefc"></tmpHefcToHefc>
  </v-app>
</template>




<script>
import rmHefc from "@/views/eign/hefc/rmHefc"; 
import sentHefcByEmail from "@/views/eign/hefc/sentHefcByEmail"; 
import tmpHefcToHefc from "@/views/eign/hefc/tmpHefcToHefc";
import rmHefr from "@/views/eign/hefc/hefr/rmHefr";
import addHefr from "@/views/eign/hefc/hefr/addHefr";
import defNavBar from '@/components/ui/navbars/navbar.vue';

export default {
  components: {
    rmHefc,
    rmHefr,
    addHefr,
    sentHefcByEmail,
    tmpHefcToHefc,
    defNavBar
  },
  props: ['hefc_encrid'],
  data() {
    return {
      hefc: {
        action_items: []  /* moet pre defined ivm length check */
      },
      snackbar: false,
      snackbarMessage: '',
      hfrt_codeKeuzes: [],
    }
    
  },
  mounted() {
    this.$axios
      .post("ares/json/ares/eign/hefc/getHefcTmp.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getHefcTmp"
        },
        getHefcTmp: {
          hefc_encrid: this.hefc_encrid
       }
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           this.hefc = res.data.getHefcTmp;
           document.title = 'Host booking ' + res.data.getHefcTmp.hefc_nr;
        }
      });

  },
  methods: {
    rmHefr(hefr_encrid) {
       this.$refs.rmHefr.open(hefr_encrid);
    },
    addHefr(hefc_encrid) {
       this.$refs.addHefr.open(hefc_encrid);
    },
    actionClick(action) {
      if (action == "rmHefc") {
        this.$refs.rmHefc.open(this.hefc_encrid);
      }
      if (action == "sentHefcByEmail") {
        this.$refs.sentHefcByEmail.open(this.hefc_encrid);
      }
      if (action == "tmpHefcToHefc") {
        this.$refs.tmpHefcToHefc.open(this.hefc_encrid);
      }
    }
  }
};

</script> 

